export default {
  computed: {
    discussion() {
      return {};
    },
  },
};
